import type { Translations } from "../types";

const th: Translations = {
  "meta.title": "คลิกตามแผนที่ประเทศ",
  "meta.description":
    "แผนที่โลกแบบอินเทอร์แอกทีฟ: คลิกฟรีตามประเทศ พร้อมการสนับสนุนแบบชำระเงินผ่าน Stripe, PayPal และ Buy Me a Coffee",

  "app.title": "คลิกตามแผนที่ประเทศ",

  "map.intro":
    "คลิกประเทศบนแผนที่เพื่อโหวตให้ฟรี หรือส่งการสนับสนุนทางการเงิน - ทั้งสองอย่างจะถูกนับรวมในตารางอันดับด้านล่าง แผนที่นี้สะท้อนเพียงการสนับสนุนภายในแอปนี้เท่านั้น ไม่ใช่ความมั่งคั่งของประเทศหรือ GDP ที่แท้จริง",
  "map.verifying": "กำลังยืนยัน …",
  "map.confirmNotRobot": "ก่อนที่จะเพิ่มคลิกฟรีได้ โปรดยืนยันอย่างรวดเร็วว่าคุณไม่ใช่โปรแกรมอัตโนมัติ:",
  "map.tryAgain": "ลองอีกครั้ง",
  "map.registeringClick": "กำลังบันทึกคลิก …",
  "map.selectedCountry": "ประเทศที่เลือก: {name}",
  "map.selectFirstFeedback": "เลือกประเทศแล้ว หากต้องการเพิ่มคลิกฟรี โปรดยืนยันด้านล่างก่อนว่าคุณไม่ใช่โปรแกรมอัตโนมัติ",
  "map.verificationExpired": "การยืนยันหมดอายุแล้ว - โปรดยืนยันอีกครั้งว่าคุณไม่ใช่โปรแกรมอัตโนมัติ",
  "map.slowDown": "ช้าลงอีกนิด - โปรดรอสักครู่ก่อนคลิกครั้งถัดไป",
  "map.clickFailed": "ไม่สามารถบันทึกคลิกได้ กรุณาลองอีกครั้ง",
  "map.clickErrorGeneric": "เกิดข้อผิดพลาดในการบันทึกคลิก",
  "map.leaderboardHeading": "ตารางอันดับประเทศ",
  "map.emptySelection": "เลือกประเทศบนแผนที่เพื่อคลิกหรือสนับสนุน",
  "map.loadingData": "กำลังโหลดข้อมูล …",

  "worldmap.loadError": "ไม่สามารถโหลดแผนที่ได้",
  "worldmap.resetZoom": "รีเซ็ตการซูม",
  "worldmap.resetButton": "⤾ รีเซ็ต",
  "worldmap.loadingMap": "กำลังโหลดแผนที่ …",
  "worldmap.unknownCountry": "ไม่ทราบ",
  "worldmap.ariaClicks": "{name}: {clicks} คลิก",
  "worldmap.tooltipClicks": "{clicks} คลิก",

  "legend.fewer": "คลิกน้อย",
  "legend.more": "คลิกมาก",

  "list.empty": "ยังไม่มีคลิก มาเป็นคนแรกกันเถอะ!",
  "list.ariaLabel": "ตารางอันดับประเทศตามจำนวนคลิก",

  "human.siteKeyMissing": "ยังไม่ได้ตั้งค่า VITE_TURNSTILE_SITE_KEY - โปรดดู README สำหรับการตั้งค่า",
  "human.verificationFailedGeneric": "การยืนยันล้มเหลว",
  "human.networkError":
    "ไม่สามารถติดต่อระบบยืนยันได้ (ข้อผิดพลาดเครือข่าย) - ตรวจสอบ VITE_SUPABASE_URL ว่า verify-human ถูกดีพลอยแล้ว และ ALLOWED_ORIGIN; ดู README/NAVODILA",
  "human.verificationFailedRetry": "การยืนยันล้มเหลว โปรดลองอีกครั้ง",

  "provider.stripe": "💳 บัตร (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "ประเทศที่เลือก",
  "panel.currentlyRanked": "ขณะนี้อยู่อันดับ #{rank}",
  "panel.shareCopied": "คัดลอกแล้ว ✓",
  "panel.shareShared": "แชร์แล้ว ✓",
  "panel.shareButton": "🔗 แชร์",

  "panel.tableClicks": "คลิก",
  "panel.tableFree": "ฟรี",
  "panel.tablePaid": "ชำระเงิน",
  "panel.rowAllTime": "ตลอดกาล",
  "panel.rowThisYear": "ปีนี้",
  "panel.rowThisWeek": "สัปดาห์นี้",
  "panel.rowToday": "วันนี้",

  "panel.totalCombined": "รวมทั้งหมด:",
  "panel.totalSupport": "การสนับสนุนรวม:",

  "panel.paymentMethod": "วิธีการชำระเงิน",
  "panel.noPaymentMethod": "ขณะนี้ไม่มีวิธีการชำระเงินให้เลือก",
  "panel.supportAmount": "จำนวนเงินสนับสนุน (EUR)",
  "panel.amountRange": "จำนวนเงินควรอยู่ระหว่าง {min} ถึง {max}",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "คลิกแบบชำระเงินโดยประมาณ:",
  "panel.ratioInfo":
    "อัตราส่วน: {a} = {b} คลิก (เช่น {c} = {d} คลิก) นี่เป็นเพียงการประมาณก่อนการชำระเงิน - จำนวนคลิกสุดท้ายจะถูกคำนวณและยืนยันโดยเซิร์ฟเวอร์เสมอ โดยอ้างอิงจากการชำระเงินที่ได้รับการยืนยันจริง",
  "panel.preparing": "กำลังเตรียมการ …",
  "panel.continueWith": "ดำเนินการต่อด้วย {provider}",
  "panel.choosePaymentMethod": "เลือกวิธีการชำระเงิน",
  "panel.bmcUsernameMissing": "ยังไม่ได้ตั้งค่า VITE_BMC_USERNAME - โปรดดู README สำหรับการตั้งค่า",
  "panel.paypalClientIdMissing": "ยังไม่ได้ตั้งค่า VITE_PAYPAL_CLIENT_ID - โปรดดู README สำหรับการตั้งค่า",

  "panel.paypalAmountInfo": "จำนวนเงิน: {amount} (โดยประมาณ {clicks} คลิก) กรุณาชำระเงินให้เสร็จสิ้นด้วยปุ่ม PayPal ด้านล่าง",
  "panel.back": "← กลับ",

  "panel.bmcWarningTitle": "⚠️ ก่อนดำเนินการต่อไปยัง BuyMeCoffee:",
  "panel.bmcWarningBody":
    "วางรหัสด้านล่างนี้ลงในช่องข้อความ/บันทึกตอนชำระเงิน — นี่เป็นวิธีเดียวที่เราจะทราบว่าคุณกำลังสนับสนุนประเทศใด หากไม่มีรหัสนี้ เราจะไม่สามารถระบุได้ว่าการชำระเงินนี้เป็นของประเทศใด",
  "panel.copy": "คัดลอก",
  "panel.copied": "คัดลอกแล้ว ✓",
  "panel.suggestedAmount": "จำนวนเงินที่แนะนำ:",
  "panel.bmcAmountNote":
    "(โดยประมาณ {clicks} คลิก) น่าเสียดายที่ BuyMeCoffee ไม่รองรับการส่งจำนวนเงินผ่านลิงก์ — โปรดกรอก/เลือกจำนวนเงินเองบนเว็บไซต์ของพวกเขา จำนวนคลิกจริงจะคำนวณจากจำนวนเงินที่คุณส่งจริงบน BuyMeCoffee เสมอ ไม่ใช่จากการประมาณนี้",
  "panel.openBmc": "เปิด BuyMeCoffee และดำเนินการต่อ →",
  "panel.waitingProvider": "กำลังรอการยืนยันการชำระเงินจากผู้ให้บริการชำระเงิน …",
  "panel.waitingConfirmation": "กำลังรอการยืนยันการชำระเงิน …",
  "panel.timedOut":
    "การตรวจสอบหมดเวลา หากคุณชำระเงินเสร็จแล้ว แผนที่จะอัปเดตทันทีที่เซิร์ฟเวอร์ได้รับการยืนยัน - บางครั้งอาจใช้เวลานานขึ้นเล็กน้อย",
  "panel.checkAgain": "ตรวจสอบอีกครั้ง",

  "panel.cancelled": "การชำระเงินถูกยกเลิกหรือไม่สำเร็จ แผนที่ยังไม่มีการเปลี่ยนแปลง",
  "panel.tryAgain": "ลองอีกครั้ง",

  "panel.confirmed": "✅ ยืนยันการสนับสนุนแล้ว!",
  "panel.confirmedBody": "{country} ได้รับ {clicks} คลิกแบบชำระเงินมูลค่า {amount}",

  "panel.errorPreparingSupport": "เกิดข้อผิดพลาดในการเตรียมการสนับสนุนของคุณ",
  "panel.errorPreparingPayment": "เกิดข้อผิดพลาดในการเตรียมการชำระเงิน",
  "panel.errorConfirmingPayment": "เกิดข้อผิดพลาดในการยืนยันการชำระเงิน",
  "panel.errorPayingPaypal": "เกิดข้อผิดพลาดในการชำระเงินด้วย PayPal",

  "share.unranked": "{flag}{country} ต้องการการสนับสนุนจากคุณบนแผนที่โลก!\nช่วยให้ประเทศนี้ไต่อันดับขึ้นไป 👇",
  "share.rank1": "{flag}{country} ขณะนี้อยู่อันดับ #1!\nช่วยให้เรารักษาตำแหน่งสูงสุดไว้ 👇",
  "share.rankN": "{flag}{country} ขณะนี้อยู่อันดับ #{rank}!\nช่วยให้เราขึ้นสู่ #1 👇",

  "language.switcherLabel": "ภาษา",
};

export default th;
